// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-guarded-component{position:relative}.ac-guarded-component__block-layer{position:absolute;z-index:9;width:100%;height:100%;background:rgba(255,255,255,0.5)}\n", ""]);
// Exports
module.exports = exports;
